import type { useBilling } from '../../context/BillingContext';

/**
 * Plan-based navigation (SRS #140). The server says which navigation entry
 * needs which feature; the layouts only ask "is this entry locked, and what
 * should the tooltip say".
 */
type Billing = ReturnType<typeof useBilling>;

const pretty = (tier: string) => tier.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function planLock(billing: Billing, entry: string): { locked: boolean; title: string } {
  const feature = billing.navigationFeature(entry);
  if (!feature || billing.loading) return { locked: false, title: '' };
  if (billing.canUse(feature)) return { locked: false, title: '' };
  const tier = billing.upgradeTierFor(feature);
  return {
    locked: true,
    title: tier ? `Included in the ${pretty(tier)} plan — click to upgrade` : 'Not included in your plan — click to upgrade',
  };
}
